enum Theme {
    Dark = "dark",
    Light = "light"
}

enum ThemePreference {
    System = "system",
    Dark = "dark",
    Light = "light"
}

const THEME_TO_CSS_CLASS = {
    [Theme.Light]: "light-theme",
    [Theme.Dark]: "dark-theme"
};

const THEME_PREFERENCE_TO_VERBOSE_NAME = {
    [ThemePreference.System]: "System",
    [ThemePreference.Light]: "Light",
    [ThemePreference.Dark]: "Dark"
};

const FORCED_LIGHT_THEME_CLASS = "forced-light-theme";

function getThemeCSSClass(theme: Theme): string {
    return THEME_TO_CSS_CLASS[theme];
}

function getSystemThemeMediaQuery(): MediaQueryList {
    return window.matchMedia("(prefers-color-scheme: dark)");
}

function getCurrentSystemTheme(): Theme {
    return getSystemThemeMediaQuery().matches ? Theme.Dark : Theme.Light;
}

function getThemePreferenceVerboseName(themePreference: ThemePreference): string {
    return THEME_PREFERENCE_TO_VERBOSE_NAME[themePreference];
}

export {
    Theme,
    ThemePreference,
    FORCED_LIGHT_THEME_CLASS,
    getThemeCSSClass,
    getSystemThemeMediaQuery,
    getCurrentSystemTheme,
    getThemePreferenceVerboseName
};
